import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCalendarCheck } from "@fortawesome/free-regular-svg-icons"

export const CalendarCheckRegular = (props) => {
  return <FontAwesomeIcon faIcon={faCalendarCheck} {...props} />
}
